import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { SubGroup } from './sub-group';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { SubGroupColumnComponent } from './sub-group-column.component';

export interface ClientSideSubGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, SubGroup> {
  rowGroup?: boolean;
}

export interface ServerSideSubGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, SubGroup>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type SubGroupColumnOptions<TRow extends object> = ClientSideSubGroupColumnOptions<TRow> | ServerSideSubGroupColumnOptions<TRow>;

export function subGroupColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: SubGroupColumnOptions<TRow>): EntityColumn<TRow, SubGroup>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.artuntergrp} - ${v.bezeichnung}`,
    sortBy: v => v.artuntergrp,
    cellRenderer: SubGroupColumnComponent,
    serverSideSortField: 'artuntergrp',
  }, entityRef => {
    stringColumn(entityRef, {
      colId: 'number',
      header: translator('Untergruppe'),
      getValue: v => v.artuntergrp
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Name'),
      getValue: v => v.bezeichnung
    });
  });
}
